import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import BillBoard from '../advertisements/BillBoard';
import PopUpAd from '../advertisements/PopUpAd';
import LargeRectangle from '../advertisements/LargeRectangle';
import adService from '../advertisements/service/adService';
import { ReviewsAndComments } from './reviews/ReviewsAndComments';
import Loader from '../utility/Loader';
import { CardsRow } from './cards/CardsRow';
import { PostContent } from './PostContent';
import { ButtonStyle } from '../UIElements/Buttons/ButtonStyle';
import styles from './forms/addpost.module.css';
import { LinkButton } from '../UIElements/Link_Button/LinkButton';
import Report from '../Report';
import MetaDecor from '../MetaDecor';
import authservice from '../Authentication/service/authservice';
import listingService from './service/listingService';

class SingleListing extends Component {

    constructor(props) {
        super(props);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.state = {
            singleListing: {},
            listingHistory: [this.props.match.params.hpId],
            currentIndex: -1,
            selectedPlace: {},
            similar_listings: [],
            isViewed: [],
            listingId: null,
            is_login: false,
            listingReviewGlance: {},
            popupAd: [],
            error: null,
            isMaster: authservice.getSubscriptionType() === 'MASTER',
        }
    };
    popupAds = [];
    popupWaitTimeout = null;
    popupTimeOut = false

    similarListingHeader = {
        business: "Similar Businesses",
        job: "Similar Jobs",
        event: "Similar Events",
        news: "More Happy News to Read",
        article: "More Articles to Read",
        reviews: "More Reviews to Read",
        photos: "More Photos to See",
        album: "More Photos to See"
    }

    componentDidMount() {
        window.scrollTo(0, 0); //while loading the component it will focus top
        window.addEventListener('scroll', this.showPopupAd)
        //this.getAdsByListing(this.props.location.state)
        //this.callListingDetails(this.props.match.params.hpId)
        if (this.props.match.params.hpId) {
            this.setState({
                listingHistory: [this.props.match.params.hpId],
                listingId: this.props.match.params.hpId,
                currentIndex: 0,
            }, () => {
                this.callListingDetails(this.props.match.params.hpId);
            });
        }

        axios.put(process.env.REACT_APP_BACKEND_URL + `/hpmgr/listing/update-views/v2?listingId=${this.props.match.params.hpId}&section=${this.props.location.state ? this.props.location.state.place : 'basic'}`).catch(err => {
            console.log(err)
        })
    }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (this.state.singleListing.hpId !== this.state.listingId && this.state.listingId) {
    //         window.scrollTo(0, 0); //while loading the component it will focus top
    //         this.callListingDetails(this.state.listingId)
    //         this.setState({ listingId: null })
    //     }
    // }

    // componentDidUpdate(prevProps, prevState) {
    //     if (prevState.listingId !== this.state.listingId) {
    //         this.callListingDetails(this.state.listingId);
    //     }
    // }

    componentWillUnmount() {
        this.popupWaitTimeout && clearTimeout(this.popupWaitTimeout)
        this.props.searchingData({})
    }

    isEmpty = (obj) => {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    openModal = () => {
        this.setState({ open: true });
    }
    closeModal = () => {
        this.setState({ open: false });
    }

    callListingDetails = (hpId) => {
        if (!hpId) {
            this.setState({ error: 'Invalid URL' })
            return
        }
        let searching = (this.props.location.state && this.props.location.state.isSearching) || (this.props.location.search && this.props.location.search.includes("searching=true"))
        Loader.runSpinner()
        this.setState({ singleListing: {} }, () => {

            axios.get(process.env.REACT_APP_BACKEND_URL + `/hpmgr/listing/getlistings/${hpId}?searching=${false}&${this.props.is_login ? 'user_id=' + authservice.getCurrentUserid() : 'guest_id=' + authservice.getCookie('hp.rocks.soon')}`).then(response => {
                this.setState({ singleListing: response.data });
                const businessName = this.state.singleListing.businessName.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-');
                this.props.history.push(`/l/${businessName}/${this.state.singleListing.hpId}`);
                this.props.currentPost(response.data)
                //if (!this.props.location.state || !this.props.location.state.searchCriteria) {}
                let isViewed = false, place = null;
                if (this.props.location.state) {
                    isViewed = this.props.location.state.isViewed;
                    place = this.props.location.state.place;
                }

                let isSearching = false, searchCriteria = {};

                if (this.props.location.state && response.data.listingType !== 'article' && response.data.listingType !== 'news' && response.data.listingType !== 'photos' && response.data.listingType !== 'album' && response.data.listingType !== 'reviews') {
                    isSearching = this.props.location.state.isSearching;
                    searchCriteria = this.props.location.state.searchCriteria
                }

                const paramData = {
                    searchCriteria: {
                        categories: [],
                        subCategories: [],
                        ...this.props.current_coords,
                        listingCategory: localStorage.setItem('categories', [searchCriteria.categories]),
                        listingSubCategory: localStorage.setItem('subCategories', [searchCriteria.subCategories]),
                        category: isSearching ? [...searchCriteria.category] : [],
                        subCategory: isSearching ? [...searchCriteria.subCategory] : [],
                        state: isSearching ? [...searchCriteria.state] : [],
                        city: isSearching ? [...searchCriteria.city] : [],
                        locality: isSearching ? [...searchCriteria.locality] : [],
                        neighbourhood: isSearching ? [...searchCriteria.neighbourhood] : [],
                        visitorLocation: true,
                        loadAds: response.data.eligibleToShowAds,
                    },
                    isViewed: isViewed,
                    place: place,
                }

                if (response.data.order && (response.data.businessPackage || response.data.order.featured || response.data.order.sponsored))
                    paramData.searchCriteria.showBanner = false;
                else
                    paramData.searchCriteria.showBanner = true;

                paramData.searchCriteria.listingPackage = 'free';

                this.getAdsByListing(paramData)

                if (!response.data.order) {
                    if (this.props.location.state.featured)
                        this.setState({ similar_listings: this.props.location.state.featured, isViewed: this.props.location.state.viewedItems })
                } else {
                    this.setState({ similar_listings: [] })
                }
                Loader.stopSpinner();
            }).catch(error => {
                Loader.stopSpinner();
                if (error.response)
                    this.setState({ error: error.response.data })
            }).catch(err => {
                console.log(err, 'getting data failed');
            });
        })
    }


    goToNextListing = () => {
        const { listingHistory, currentIndex } = this.state;

        const searchDTO = {
            category: this.state.singleListing.categories.map(category => category.category),
            subCategory: this.state.singleListing.subCategories.map(subCategory => subCategory.subCategory),
            country: this.state.singleListing.country,
            visitorsState: this.state.singleListing.states[0],
            visitorsCity: this.state.singleListing.cities[0],
            visitorsLocality: this.state.singleListing.localities[0],
            visitorsNeighbourhood: this.state.singleListing.neighbourhoods[0],
            latitude: 17.4382401,
            longitude: 78.4558889,
            listingType: this.state.singleListing.listingType,
            userId: authservice.getCurrentUserid(),
            guestId: authservice.getCookie('hp.rocks.soon'),
            hpId: this.state.singleListing.hpId
        };

        axios.post(`${process.env.REACT_APP_BACKEND_URL}/hpmgr/listing/next-listing/`, searchDTO)
            .then(response => {
                const nextListing = response.data;

                if (nextListing && nextListing.hpId) {
                    const updatedHistory = [...listingHistory];
                    const newIndex = currentIndex + 1;

                    // If it's a new listing, add it to the history
                    if (newIndex === updatedHistory.length) {
                        updatedHistory.push(nextListing.hpId);
                    }

                    // Update state for history and index
                    this.setState({
                        listingId: nextListing.hpId,
                        currentIndex: newIndex,
                        listingHistory: updatedHistory,
                    }, () => {
                        // Call `callListingDetails` to fetch new listing data
                        this.callListingDetails(nextListing.hpId);

                        // Update URL dynamically

                    });
                } else {
                    console.error("No next listing available.");
                }
            })
            .catch(err => {
                console.error("Error fetching next listing:", err);
            });
    };

    goToPreviousListing = () => {
        const { listingHistory, currentIndex } = this.state;
    
        if (currentIndex > 0) {
            const previousListingId = listingHistory[currentIndex - 1];
    
            this.setState({
                listingId: previousListingId,
                currentIndex: currentIndex - 1,
            }, () => {
                this.callListingDetails(previousListingId);
    
                const businessName = this.state.singleListing.businessName.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-');
                this.props.history.push(`/l/${businessName}/${previousListingId}`);
            });
        } else {
            console.log("Already at the first listing.");
        }
    };
    


    getAdsByListing = (data) => {
        if (data && data.searchCriteria) {
            const searchCriteria = Object.assign({}, data.searchCriteria)
            searchCriteria.listingId = this.props.match.params.hpId;
            searchCriteria.isViewed = data.isViewed;
            searchCriteria.place = data.place;
            this.props.searchingData(searchCriteria)
            if (data.searchCriteria.loadAds && !data.isViewed) {
                adService.getAdsByListing(searchCriteria, 'popup').then(response => {
                    this.popupWaitTimeout = setTimeout(() => {
                        if (this.popupAds.length > 0 && this.state.popupAd.length === 0) {
                            this.popupTimeOut = true
                        }
                        if (this.props.isPageVisible)
                            this.showPopupAd()
                    }, 60000)
                    this.popupAds = response
                })
            }
        }
    }

    showPopupAd = () => {
        if (this.popupAds.length > 0 && this.state.popupAd.length === 0) {
            if (this.popupTimeOut) {
                if (this.popupWaitTimeout)
                    clearTimeout(this.popupWaitTimeout)
                this.setState({ popupAd: this.popupAds })
                this.popupTimeOut = false
            }
        }
    }

    goToPreviousPage = () => {
        this.props.history.push('/')
    }

    display = (file) => {
        return window.URL.createObjectURL(file);
    }

    popupCleanUp = () => {
        this.setState({ popupAd: [] })
    }

    getListingDetails = (listing) => {
        this.setState({ listingId: listing.hpId });
        const { isSearching, searchCriteria } = this.props.location.state
        const businessName = listing.businessName.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-')
        this.props.history.replace(`/l/${businessName}/${listing.hpId}`, {
            place: 'featured',
            isViewed: this.props.viewedListings[listing.hpId],
            searchCriteria: searchCriteria,
            isSearching: true,
        });
    }

    render() {
        if (this.state.singleListing.businessName !== undefined) {
            return (
                <>
                    <div className={styles.listing_preview}>
                        <MetaDecor></MetaDecor>
                        {(!this.props.viewedListings.includes(parseInt(this.props.match.params.hpId)) && this.state.popupAd.length) ?
                            <PopUpAd
                                listingData={{
                                    viewedOnListing: parseInt(this.props.match.params.hpId),
                                    listingTitle: this.state.singleListing.businessName,
                                    ...this.props.search_data,
                                }}
                                cleanUp={this.popupCleanUp}
                                ads={this.state.popupAd}
                            /> : null}
                        <div className="grid_container">
                            <PostContent listing={this.state.singleListing} listingReviewGlance={this.state.listingReviewGlance} videoPause={this.state.singleListing.listingType === 'article' ? this.popupTimeOut : null} />
                            {(this.state.similar_listings.length > 0 && !this.state.singleListing.order) ?
                                <div className="row form-row">
                                    <div className="form-group col-md-12">
                                        <h2 className="preview_header">{this.similarListingHeader[this.state.singleListing.listingType]}</h2>
                                        <CardsRow listings={this.state.similar_listings} showContent={this.getListingDetails} viewedContentIds={this.props.viewedListings} type={this.state.singleListing.listingType} />
                                    </div>
                                </div> : null}
                            {(this.state.singleListing.listingType === 'business' || this.state.singleListing.listingType === 'news' || this.state.singleListing.listingType === 'reviews' || this.state.singleListing.listingType === 'photos' || this.state.singleListing.listingType === 'album' || (this.state.singleListing.listingType === 'article' && this.state.singleListing.user.userName !== 'Mani1268')) && (this.state.singleListing.businessPackage === 'advanced' || this.state.singleListing.businessPackage === 'premium' || this.state.singleListing.businessPackage === '')
                                ? <ReviewsAndComments listing={this.state.singleListing} setReviewsGlance={(listingReviewGlance) => this.setState({ listingReviewGlance })} /> : null}
                            <div className="row">
                                <div className="form-group col-md-12 text-left">
                                    <ButtonStyle handleClick={this.goToPreviousPage} type="" className="btn">Back</ButtonStyle>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-6 text-left">
                                    <ButtonStyle disabled={this.state.currentIndex <= 0} handleClick={this.goToPreviousListing} type="" className="btn">Previous</ButtonStyle>
                                </div>
                                <div className="form-group col-md-6 text-right">
                                    <ButtonStyle handleClick={this.goToNextListing} type="" className="btn">Next</ButtonStyle>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-12 text-left">
                                    <span className={styles.contact_link}><LinkButton handleClick={this.openModal} className={`social-icon text-xs-center ${styles.reportLink}`} text="For Any Feedback or Copyright Issues - Click Here" /></span>
                                </div>
                            </div>
                            <Report open={this.state.open} listing={this.state.singleListing}
                                closeModal={this.closeModal} />
                        </div>
                    </div>
                    <div className="listings_footer">
                        <div className={`${styles.large_rect} row`}>
                            <LargeRectangle spot={"-1"} />
                        </div>
                        <div className={`${styles.billBoard}`}>
                            <BillBoard spot={"-1"} />
                        </div>
                    </div>
                </>
            )
        } else {
            return <h2 className="error">{this.state.error}</h2>;
        }
    }
}

const mapStateToProps = state => {
    return {
        listing_id: state.listing_id,
        is_login: state.is_login,
        viewedListings: state.viewedListings,
        search_data: state.search_data,
        current_coords: state.current_coords,
        isPageVisible: state.isPageVisible,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        currentPost: (currentPost) => dispatch({ type: 'CURRENT_POST', currentPost: currentPost }),
        searchingData: (data) => dispatch({ type: "Seraching_Data", search_data: data }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleListing);